import { k } from "../core/kaplay";
import { addButton, addTitle, addUiRoot } from "../ui/layout";

export function menuScene() {
    const ui = addUiRoot();
    addTitle(ui, "BikeDown", -260, 128);
    addButton(ui, "Ride", -20, () => k.go("mountain"));
    addButton(ui, "Settings", 110, () => k.go("settings"));
    k.onKeyPress(["enter", "space"], () => k.go("mountain"));
}
